









































import Vue from "vue";
import NotFound from "@/views/NotFound.vue";


export default Vue.extend({
  name: "App",
  computed: {
    routes(): Array<{
      name: string;
      route: string;
    }> {
      return [
        {
          name: "About",
          route: "/about",
        },
        {
          name: "Home",
          route: "/home",
        },
        {
          name: "Clusters",
          route: "/clusters",
        },
      ];
    },
  },
});
